import { get } from 'lodash'
import { CONFIGURATION_KEYS } from '../../constants/enums'

export default function(fields = {}, configuration) {
  const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

  const data = {
    ...fields,
    minAgeValue: minAgeCfg
  }

  return data
}
